import {
    ADD_CONFIDENTIALITY,
    ADD_EXTERNALCOLLABORATION,
    ADD_NAME,
    ADD_URL,
    ADD_ONLINE_LOCATION,
    ADD_PURPOSE,
    ADD_QUOTA,
    ADD_TEMPLATE,
    ADD_TITLE,
    CLEAR_SITE_ELEMENTS,
    SET_ORDER_CREATED,
    SET_ONPREMISE_STATE,
    ADD_OWNER,
    ADD_GDPR,
    ADD_SENSITIVE_GDPR,
    CONFIRM_GDPR,
    ADD_APPROVER,
    ADD_LOCATION,
    SET_GEOGRAPHY,
    SET_MANAGEMENT,
    ADD_PMOS,
    ADD_PROJECT_MANAGER,
    ADD_SPONSOR,
    ADD_STEERING_COMMITTEE,
    ADD_MEMBERS,
    ADD_IDGINTEGRATION
} from '../actions/types';
import { String } from '../helpers/HelperMethods'

const initialState = {
    OnPremiseState : false,
    NextStepRequested: false,
    Name : '',
    Title: '',
    Confidentiality: null,
    ExternalCollaboration: null,
    OnlineLocation:null,
    SiteType: null,
    QuotaSize: null,
    Purpose : '',
    Template: null,
    Owner: null,
    Approver: null,
    OrderCreated: null,
    Gdpr: null,
    SensitiveGdpr: null,
    ConfirmGdpr: false,
    Location: '',
    geography: null,
    management: null,
    isMsTeams: false,
    isIATU: false,
    isIAPCP: false,
    PMOs : null,
    ProjectManager : null,
    Sponsor : null,
    SteeringCommittee : null,
    Members : null,
    Url : null,
    idgIntegration: {
        instanceCode: null,
        serieNumber: null,
        subSerieDelimiter: null,
        idgValidationNeeded: false,
        useCustomValues: false,
        useExistingNumber: false,
        existingSerieNumber: null,
        existingProjectName: null
    }
};
export default function(state = initialState, action) {
    switch (action.type) {
        case ADD_NAME:
            const name = state.Template && state.Template.config && state.Template.config.siteCustomName
                        ? (state.idgIntegration && state.idgIntegration.existingSerieNumber && state.Template.config.idgIntegration.existingNumberSiteCustomName 
                            ? String.format(state.Template.config.idgIntegration.existingNumberSiteCustomName, state.idgIntegration.existingSerieNumber)
                            : state.Template.config.siteCustomName)
                        : action.payload.substr(0, 90);
            const url = state.Location
                        ? state.Location.address.replace(/\/+$/, '') + `/${state.isMsTeams ? 'teams' : 'sites'}/` + name
                        : null;

            return {
                ...state,
                Name: name,
                Url: url
            };
        case ADD_URL:
            return {
                ...state,
                Url: action.payload
            };
        case ADD_TITLE:
            return {
                ...state,
                Title: action.payload
            };
        case ADD_CONFIDENTIALITY:
            return {
                ...state,
                Confidentiality: action.payload
            };
        case ADD_EXTERNALCOLLABORATION:
            return {
                ...state,
                ExternalCollaboration: action.payload
            };
        case ADD_PURPOSE:
            return {
                ...state,
                Purpose: action.payload
            };
        case ADD_TEMPLATE:
            const isMsTeams = action.payload.siteType === 'Team';
            const isIATU = action.payload.internalName === 'IATU';
            const isIAPCP = action.payload.internalName === 'IAPCP';
            const idgIntegration = (action.payload.config || {}).idgIntegration

            return {
                ...state,
                Template: action.payload,
                isMsTeams,
                ExternalCollaboration: isMsTeams 
                    ? true 
                    : action.payload.config.externalSharingDefault,
                isIATU,
                isIAPCP,
                Name: '',
                Title: '',
                idgIntegration
            }
        case ADD_QUOTA:
            return {
                ...state,
                QuotaSize: action.payload
            }
        case ADD_ONLINE_LOCATION:
            return {
                ...state,
                OnlineLocation: action.payload
            }
        case SET_ONPREMISE_STATE:
            return{
                ...state,
                OnPremiseState: action.payload
            }
        case ADD_OWNER:
            return {
                ...state,
                Owner: action.payload
            }
        case ADD_APPROVER:
            return {
                ...state,
                Approver: action.payload
            }
        case ADD_PMOS:
            return {
                ...state,
                PMOs: action.payload
            }
        case ADD_PROJECT_MANAGER:
            return {
                ...state,
                ProjectManager: action.payload
            }
        case ADD_SPONSOR:
            return {
                ...state,
                Sponsor: action.payload
            }
        case ADD_STEERING_COMMITTEE:
            return {
                ...state,
                SteeringCommittee: action.payload
            }
        case ADD_MEMBERS:
            return {
                ...state,
                Members: action.payload
            }
        case SET_ORDER_CREATED:
            return{
                ...state,
                OrderCreated: action.payload
            }

        case ADD_GDPR:
            return{
                 ...state,
                 Gdpr: action.payload
        }

        case ADD_SENSITIVE_GDPR:
            return{
                ...state,
                SensitiveGdpr: action.payload
            }
        case CONFIRM_GDPR:
            return{
                ...state,
                ConfirmGdpr: action.payload
            }
        case SET_GEOGRAPHY:
            return {
                ...state,
                geography: action.payload
            };
        case SET_MANAGEMENT:
            return {
                ...state,
                management: action.payload
            };
        case CLEAR_SITE_ELEMENTS:
            return{
                ...state,
                ...initialState
            }
        case ADD_LOCATION:
            return {
                ...state,
                Location: action.payload
            }
        case ADD_IDGINTEGRATION:
            return {
                ...state,
                idgIntegration: action.payload
            }
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/siteReducer.js